import { useBookmarks } from "@/hooks/useBookmarks";

interface BookmarkButtonProps {
  id: string;
  label?: string;
  className?: string;
  tone?: "light" | "icon";
}

export default function BookmarkButton({
  id,
  label = "收藏",
  className = "",
  tone = "light",
}: BookmarkButtonProps) {
  const { isSaved, toggle } = useBookmarks();
  const active = isSaved(id);

  if (tone === "icon") {
    return (
      <button
        type="button"
        aria-pressed={active}
        aria-label={active ? "取消收藏" : "收藏此话题"}
        title={active ? "取消收藏" : "收藏此话题"}
        onClick={() => toggle(id)}
        className={`w-9 h-9 flex items-center justify-center rounded-full border transition-colors cursor-pointer ${
          active
            ? "bg-accent-500 border-accent-500 text-foreground-950"
            : "bg-background-50/90 border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
        } ${className}`}
      >
        <i className={active ? "ri-bookmark-fill text-base" : "ri-bookmark-line text-base"}></i>
      </button>
    );
  }

  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={() => toggle(id)}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
        active
          ? "bg-accent-500 border-accent-500 text-foreground-950"
          : "bg-background-50 border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
      } ${className}`}
    >
      <i className={active ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
      <span>{active ? "已收藏" : label}</span>
    </button>
  );
}